export const DASHBOARD_ROUTE = "dashboard";
export const LOGIN_ROUTE = "login";
export const SIGNUP_ROUTE = "signup";
export const ADD_ACCOUNT = "add-account";
